import Vue from 'vue'
import logger from '@/lib/logger.js'

logger.log('Creating Events object')
let Events = new Vue()
Events.list = []
Events.registerEvent = event => {
    Events.list.push(event)
    return event
}

Events.EVT_USER_CHANGED = Events.registerEvent('user-changed-event')
Events.EVT_USER_POINTS_CHANGED = Events.registerEvent('user-points-changed-event')
Events.EVT_FORECAST_INV_CHANGED = Events.registerEvent('forecast-inventory-changed-event')
Events.EVT_FORECAST_CHANGED = Events.registerEvent('forecast-changed-event')
Events.EVT_ERROR = Events.registerEvent('error-event')
Events.EVT_FORECAST_VAR_INV_CHANGED = Events.registerEvent('forecast-var-inventory-changed')
Events.EVT_LAYER_OPACITY_CHANGED = Events.registerEvent('layer-opacity-changed')
Events.EVT_POINT_ADDED = Events.registerEvent('point-added-event')
Events.EVT_DUAL_PANE_CHANGED = Events.registerEvent('dual-pane-changed')
Events.EVT_POINT_DELETED = Events.registerEvent('point-deleted-event')
Events.EVT_CONFIG_CHANGED = Events.registerEvent('config-changed-event')
Events.EVT_LAYER_INV_CHANGED = Events.registerEvent('layers-inv-changed')
Events.ACTION_OPEN_FORECAST = Events.registerEvent('open-forecast-action')
Events.ACTION_MY_POINTS = Events.registerEvent('my-points-action')
Events.ACTION_SETTINGS = Events.registerEvent('settings-action')
Events.ACTION_SUBSCRIPTION = Events.registerEvent('subscription-action')
Events.ACTION_LOG_OUT = Events.registerEvent('log-out-action')
Events.ACTION_OPEN_VARIABLE = Events.registerEvent('open-variable-action')
Events.ACTION_ADD_POINT = Events.registerEvent('add-point-action')
Events.ACTION_EDIT_POINT = Events.registerEvent('edit-point-action')
Events.ACTION_PAN_TO = Events.registerEvent('pan-to-action')
Events.ACTION_PROMPT = Events.registerEvent('prompt-action')
Events.ACTION_MANAGE_POINTS = Events.registerEvent('manage-points-event')

export default Events